import $ from 'jquery'
import { getDocument, GlobalWorkerOptions, PDFWorker } from 'pdfjs-dist';
/*eslint no-undef: "error"*/

SOPHIA.pdfViewer = function(pdfPath, optWorker, pdfViewer, id) {
  GlobalWorkerOptions.workerSrc = optWorker;

  const worker = new PDFWorker(),
        url = pdfPath,
        $mainContainer = pdfViewer,
        $nextbutton = $(".next", $mainContainer),
        $prevbutton = $(".previous", $mainContainer),
        $zoominbutton = $(".zoomIn", $mainContainer),
        $zoomoutbutton = $(".zoomOut", $mainContainer),
        $pageNum = $('.pageNumber', $mainContainer),
        $allPages = $('.numPages', $mainContainer),
        $downloadButton = $('.download', $mainContainer),
        canvasId = id

  let shownPdf,
      $pageScale = $('.pageScale', $mainContainer),
      pageScale = parseFloat($pageScale.val()),
      pageNum = parseInt($pageNum.val())

  if (pageScale > 1.5 || pageScale < 1.5) {
    pageScale = parseFloat($pageScale.val());
    $pageScale.val(pageScale);
  } else {
    pageScale = 1.5;
  }

  if (pageNum > 1) {
    pageNum = parseInt($pageNum.val());
  } else {
    pageNum = 1;
  }

  $nextbutton.on('click', function() {
    if (pageNum >= shownPdf.numPages) {
      return;
    }
    pageNum++;
    displayPage(shownPdf, pageNum);
    $prevbutton.removeClass('disabled');

    if (pageNum == shownPdf.numPages) {
      $nextbutton.addClass('disabled');
    }
  });

  $prevbutton.on('click', function() {
    if (pageNum <= 1) {
      return;
    }
    pageNum--;
    displayPage(shownPdf, pageNum);
    $nextbutton.removeClass('disabled');

    if (pageNum == 1) {
      $prevbutton.addClass('disabled');
    }
  });

  $zoominbutton.on('click', function() {
    pageScale = pageScale + 0.25;
    if (pageScale == 1.25) {
      pageScale = 1.5; // because of 1.5 scale quality
    }
    displayPage(shownPdf, pageNum);
    $pageScale.val(pageScale);
  });

  $zoomoutbutton.on('click', function() {
    if (pageScale <= 0.25) {
       return;
    }
    pageScale = pageScale - 0.25;

    if (pageScale == 1.25) {
      pageScale = 1; // because of 1.5 scale quality
    }
    displayPage(shownPdf, pageNum);
    $pageScale.val(pageScale);
  });

  $pageNum.on('keydown', function(e){
    const num = parseInt($(this).val());
    if (e.keyCode == $.ui.keyCode.ENTER) {
      e.preventDefault();
      if (num <= shownPdf.numPages) {
        pageNum = num;
        displayPage(shownPdf, pageNum);
      }
    }
  });

  $downloadButton.on('click', function(event){
    event.preventDefault() // for Safari, prevent opening 2 tabs
    window.open(url, '_blank')
    return false // for Safari, prevent opening 2 tabs
  });

  function renderPage(page) {
    const scale = pageScale, // 1.5 is for better pdf quality, 1 is too low.
        viewport = page.getViewport({scale: scale});

    playerHeight();

    $(window).on('resize', function() {
      playerHeight();
    })

    $mainContainer.find('canvas').replaceWith('<canvas></canvas>');
    var $newCanvas = $mainContainer.find('canvas');

    if (pageScale == 1.5) {
      $newCanvas.css('width', '100%');
    } else {
      $newCanvas.css('width', 'auto');
    }

    const canvas = $mainContainer.find('canvas')[0],
        context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    canvas.id = canvasId;

    const renderContext = {
       canvasContext: context,
       viewport: viewport
    };

    page.render(renderContext);
  }

  function playerHeight() {
    var windowHeight = $(window).height(),
        extraHeight = 70;

    if ($('.section-buttons').length) {
      const stickyHeight = $('.section-buttons').height();
      extraHeight = stickyHeight + 70;
    }

    if ($('.grading-viewer-header').length) {
      const headerHeight = $('.grading-viewer-header').height();
      extraHeight = headerHeight + 120;
    }

    $('.pdfViewer').css('max-height', windowHeight - extraHeight);
  }

  function displayPage(pdf, num) {
    pdf.getPage(num).then(function getPage(page) { renderPage(page); });
    $pageNum.val(pageNum);
    $('i', $allPages).text(pdf.numPages);
  }

  const loadingTask = getDocument({ url: url, worker });

  loadingTask.promise.then((pdf) => {
    displayPage(pdf, pageNum);
    shownPdf = pdf;
    if (pageNum == shownPdf.numPages) {
      $nextbutton.addClass('disabled');
    } else if (pageNum == 1) {
      $prevbutton.addClass('disabled');
    }
  }, function (error) {
    console.warn(error.message);
  });
}
